import { useState } from 'react';
import PropTypes from 'prop-types';

import * as dayjs from 'dayjs';
import * as isoWeek from 'dayjs/plugin/isoWeek';

// Context.

// Api.

// Constants.
import { DATA_INITIALISING } from '../../component/Constants';

// Helpers.

// Components.
import { useParams } from "react-router-dom";
import HostTarget from "../../types/host/HostTarget";
import EventHistoryContainer from "../../container/event-history";
import EventType from "../../types/instance/EventType";
import InstanceTarget from "../../types/instance/InstanceTarget";
import HostsTabbed from "./HostsTabbed";

// DayJS plugins - note, the position of these in this file are important.
dayjs.extend(isoWeek.default);

function Events(props: { toggleMenu: Function, applyPeriod: Function, setFilterOptions: Function, hosts: HostTarget[], eventTypes: EventType[], instances: InstanceTarget[] } ) {
    const { hostId } = useParams();

    const [loading, setLoading] = useState<number>(DATA_INITIALISING);



    function refresh() {
        setLoading(DATA_INITIALISING);
    }

    return (
        <HostsTabbed
            hosts={props.hosts}
            toggleMenu={props.toggleMenu}
            applyPeriod={props.applyPeriod}
            setFilterOptions={props.setFilterOptions}
            refresh={refresh}
            loading={loading}
            activeTab="events"
            title='Host Events - DBmarlin'
            description='List of all events'
        >

            {/* Events */}
            <div className="row row-cols-1">
                <div className="col">
                    <EventHistoryContainer applyPeriod={props.applyPeriod} host={props.hosts.find(h=> h.id === Number(hostId))} eventTypes={props.eventTypes} />
                </div>
            </div>
        </HostsTabbed>
    )
}

Events.propTypes = {
    toggleMenu: PropTypes.func.isRequired,
    applyPeriod: PropTypes.func.isRequired
};

export default Events;
